import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles, useTheme } from 'react-jss'

const useStyles = createUseStyles({
    bookingWidgetTitle: ({ bgColor, theme }) => {
        const backgroundColor = bgColor == undefined ? { backgroundColor: bgColor } : {}
        return {
            ...theme.headings.bookingWidgetSelectsTitle,
            ...backgroundColor,
            color: theme.colors.white,
        }
    },
})

const BookingWidgetTitle = ({ bgColor, color, textAlign, children, disabled }) => {
    const theme = useTheme()
    const classes = useStyles({ bgColor, theme })
    return (
        <h2
            className={classes.bookingWidgetTitle}
            style={{ textAlign: textAlign, color: color, opacity: disabled ? 0.1 : 1 }}
        >
            {children}
        </h2>
    )
}

BookingWidgetTitle.defaultProps = {
    color: undefined,
    textAlign: 'left',
}

BookingWidgetTitle.propTypes = {
    color: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(undefined)]),
    textAlign: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default BookingWidgetTitle
